/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform User API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyPersonNumberStartResponse
 */
export interface VerifyPersonNumberStartResponse {
    /**
     * Session id generated by external IDP
     * @type {string}
     * @memberof VerifyPersonNumberStartResponse
     */
    sessionId: string;
    /**
     * An URL to the IDP to redirect to using the sessionId as parameter
     * @type {string}
     * @memberof VerifyPersonNumberStartResponse
     */
    redirectUrl: string;
}

export function VerifyPersonNumberStartResponseFromJSON(json: any): VerifyPersonNumberStartResponse {
    return VerifyPersonNumberStartResponseFromJSONTyped(json, false);
}

export function VerifyPersonNumberStartResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyPersonNumberStartResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'],
        'redirectUrl': json['redirectUrl'],
    };
}

export function VerifyPersonNumberStartResponseToJSON(value?: VerifyPersonNumberStartResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sessionId': value.sessionId,
        'redirectUrl': value.redirectUrl,
    };
}


